export const ROLES = Object.freeze({
  super_admin:    "Super Admin",
  facility_admin: "Facility Admin",
  doctor:         "Doctor",
  nurse:          "Nurse",
  receptionist:   "Receptionist",
  lab_technician: "Lab Tech",
  radiologist:    "Radiologist",
  cashier:        "Cashier",
  pharmacist:     "Pharmacist",  
})